import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ToastBody as ToastBody$1 } from 'reactstrap';

var ToastBody = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (jsx(ToastBody$1, __assign({ "data-testid": "toast-body" }, props, { children: children })));
};
ToastBody.displayName = 'Toast.Body';

export { ToastBody };
